import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function Home() {
  const [countryData, setCountryData] = useState(null);

  const location = useLocation();
  const query = new URLSearchParams(location.search).get("q");

  useEffect(() => {
    if (!query) return;

    async function fetchData() {
      try {
        const response = await fetch(
          `https://restcountries.com/v3.1/name/${query}`
        );
        const data = await response.json();

        if (data && !data.status && data.length > 0) {
          setCountryData(data[0]); // ✅ correct object
        } else {
          setCountryData(null);
        }
      } catch (error) {
        console.error("Error fetching country data:", error);
        setCountryData(null);
      }
    }

    fetchData();
  }, [query]);

  return (
    <div className="container mt-4">

      {/* ✅ NO SEARCH MESSAGE */}
      {!query && (
        <h4 className="text-center text-muted">
          Search for a country above...
        </h4>
      )}

      {/* ✅ SEARCH BUT NO RESULT */}
      {query && !countryData && (
        <h4 className="text-center text-danger">
          No data found for "{query}"
        </h4>
      )}

      {/* ✅ MAIN CONTENT WHEN DATA EXISTS */}
      {query && countryData && (
        <>
          {/* ✅ HERO TITLE */}
          <div className="text-center mb-4">
            <h2>{countryData.name?.common}</h2>
            <p className="text-muted">{countryData.name?.official}</p>
          </div>

          {/* ✅ QUICK STATS CARDS */}
          <div className="row g-3 mb-4">
            <div className="col-6 col-md-3">
              <div className="card text-center shadow-sm">
                <div className="card-body">
                  <h6>Population</h6>
                  <strong>{countryData.population}</strong>
                </div>
              </div>
            </div>

            <div className="col-6 col-md-3">
              <div className="card text-center shadow-sm">
                <div className="card-body">
                  <h6>Region</h6>
                  <strong>{countryData.region}</strong>
                </div>
              </div>
            </div>

            <div className="col-6 col-md-3">
              <div className="card text-center shadow-sm">
                <div className="card-body">
                  <h6>Capital</h6>
                  <strong>{countryData.capital?.join(", ")}</strong>
                </div>
              </div>
            </div>

            <div className="col-6 col-md-3">
              <div className="card text-center shadow-sm">
                <div className="card-body">
                  <h6>Area (km²)</h6>
                  <strong>{countryData.area}</strong>
                </div>
              </div>
            </div>
          </div>

          {/* ✅ MAIN INFO + FLAG */}
          <div className="row g-4 mb-4">
            <div className="col-12 col-md-7">
              <table className="table table-bordered table-fixed">
                <thead>
                  <tr>
                    <th colSpan={2}>Basic Country Information</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>Timezones</th>
                    <td>{countryData.timezones?.join(", ")}</td>
                  </tr>
                  <tr>
                    <th>Subregion</th>
                    <td>{countryData.subregion}</td>
                  </tr>
                  <tr>
                    <th>Borders</th>
                    <td>{countryData.borders?.join(", ") || "None"}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="col-12 col-md-5 d-flex justify-content-center">
              <div className="flag">
                <img src={countryData.flags?.svg} alt="Flag" />
              </div>
            </div>
          </div>

          {/* ✅ GOVERNMENT + CODES */}
          <table className="table table-bordered table-fixed mb-4">
            <thead>
              <tr>
                <th colSpan={2}>Government & Codes</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>Languages</th>
                <td>
                  {countryData.languages
                    ? Object.values(countryData.languages).join(", ")
                    : "N/A"}
                </td>
              </tr>

              <tr>
                <th>Currency</th>
                <td>
                  {countryData.currencies
                    ? Object.values(countryData.currencies).map((c) => (
                        <span key={c.name}>
                          {c.name} ({c.symbol}){" "}
                        </span>
                      ))
                    : "N/A"}
                </td>
              </tr>
            </tbody>
          </table>

          {/* ✅ EXTRA USEFUL CONTENT */}
          <table className="table table-bordered table-fixed mb-5">
            <thead>
              <tr>
                <th colSpan={2}>Additional Useful Info</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>Demonym</th>
                <td>
                  {countryData.demonyms?.eng
                    ? `${countryData.demonyms.eng.m} / ${countryData.demonyms.eng.f}`
                    : "N/A"}
                </td>
              </tr>

              <tr>
                <th>Calling Code</th>
                <td>
                  {countryData.idd
                    ? countryData.idd.suffixes.map((s, i) => (
                        <span key={i}>
                          {countryData.idd.root}
                          {s}
                          {i <
                          countryData.idd.suffixes.length - 1
                            ? ", "
                            : ""}
                        </span>
                      ))
                    : "N/A"}
                </td>
              </tr>

              <tr>
                <th>Google Map</th>
                <td>
                  <a
                    href={countryData.maps?.googleMaps}
                    target="_blank"
                    rel="noreferrer"
                  >
                    View Location
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </>
      )}
    </div>
  );
}
